import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Province } from '../../models/province.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ProvinceService {

  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getAll(country_id: number = null, state_id: number = null) {
    console.log('state_id', '\'' + state_id + '\'')
    let query: string = ((country_id != null || state_id != null) ? '?' : '');

    if (country_id != null) {
      query += 'country_id=' + country_id + (state_id != null ? '&state_id=' + state_id : '');
    } else {
      query += (state_id != null ? 'state_id=' + state_id : '');
    }
    return this.h.get('/koncentro-common/province/provinces' + query)
      .map(res => {
        return res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/province/provinces/' + record.id)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Province deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/province/provinces/', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  put(newData) {
    return this.h.put('/koncentro-common/province/provinces/', newData)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/ProvinceDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/province/province.service.ts